import { DateRange } from 'fabscale-app/models/date-range';
import { getAutoDateInterval } from 'fabscale-app/utilities/utils/date-interval';

export default function getOverTimeInterval(exactDateRange: DateRange) {
  return getAutoDateInterval(exactDateRange);
}
